import { useState } from "react";
import Jsona from "jsona";
import { visionURL } from "../config/environment";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const acknowledgementApiService = async () =>
  new JsonApiService("policy_acknowledgements", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

const activityApiService = async () =>
  new JsonApiService("policy_activities", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

const usePolicyActivities = () => {
  const [isRequesting, setIsRequesting] = useState(false);

  const fetchPolicyAcknowledgement = async id => {
    setIsRequesting(true);
    const service = await acknowledgementApiService();
    const response = await service.find(id).then(response => response.json());
    setIsRequesting(false);
    return dataFormatter.deserialize(response);
  };

  const createPolicyAcknowledgement = async data => {
    setIsRequesting(true);
    const service = await acknowledgementApiService();
    const response = await service
      .create(JSON.stringify(data))
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .catch(error => {
        setIsRequesting(false);
        throw error;
      });
    setIsRequesting(false);
    return dataFormatter.deserialize(response);
  };

  const updatePolicyAcknowledgement = async (acknowledementId, data) => {
    setIsRequesting(true);
    const service = await acknowledgementApiService();
    const response = await service
      .update(acknowledementId, JSON.stringify(data))
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .catch(error => {
        setIsRequesting(false);
        throw error;
      });
    setIsRequesting(false);
    return dataFormatter.deserialize(response);
  };

  const updatePolicyActivities = async (activityId, data) => {
    setIsRequesting(true);
    const service = await activityApiService();
    const response = await service
      .update(activityId, JSON.stringify(data))
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .catch(error => {
        setIsRequesting(false);
        throw error;
      });
    setIsRequesting(false);
    return dataFormatter.deserialize(response);
  };

  return {
    fetchPolicyAcknowledgement,
    createPolicyAcknowledgement,
    updatePolicyAcknowledgement,
    updatePolicyActivities,
    isRequesting
  };
};

export default usePolicyActivities;
